import { OpenAPIV2 } from 'openapi-types'

import { followReference } from '../util/reference'

const createRequest =
  (
    swaggerfiles: OpenAPIV2.Document,
    type: string,
    baseUrl: string,
    endpoint: string,
    functionDefinition: OpenAPIV2.OperationObject,
  ) =>
  (...args: unknown[]): { url: string; options: RequestInit } => {
    let url = baseUrl + endpoint + '?'
    const headers = new Headers({
      Accept: 'application/json',
    })
    const options: RequestInit = {
      method: type,
      headers,
    }

    ;;(functionDefinition.parameters ?? []) //
      .forEach((parameterOrRef, i) => {
        const arg = args[i]
        const parameter = followReference(swaggerfiles)(parameterOrRef)
        if (parameter.in === 'query' && typeof arg === 'number') {
          url += `${parameter.name}=${encodeURIComponent(String(arg))}&`
        } else if (parameter.in === 'header') {
          headers.set(parameter.name, String(arg))
        } else if (parameter.in === 'body') {
          options.body = JSON.stringify(arg)
        } else if (parameter.in === 'path') {
          if (arg == null)
            throw new Error(`The parameter ${parameter.name} must be defined.`)
          url = url.replace(
            `{${parameter.name}}`,
            encodeURIComponent(String(arg)),
          )
        } else if (parameter.in === 'formData' && arg != null) {
          options.body = new FormData()
          options.body.append(
            parameter.name,
            arg instanceof Blob ? arg : String(arg),
          )
        }
      })
    url = url.replace(/[?&]$/, '')
    return {
      url,
      options,
    }
  }

export default createRequest
